import { createOrGetFetchedState } from '@vista-digital/utilities';
import { Validator } from '@vista-digital/validator';
import { ocapiClient } from '../../../api-clients/ocapi/client';
import { getCacheDuration } from '../../../utils/get-cache-duration';
import { loadDataFromApi } from '../../../utils/load-data-from-api';
import { logger } from '../../../utils/logger';
import { seatingDomainStore } from '../store';
import { assignSeatLayoutRelatedData } from './utils/assign-seat-layout-related-data';
/**
 * Loads a seat layout by its unique identifier.
 * @param seatLayoutId The unique identifier of the seat layout.
 * @returns The loaded seat layout.
 */
export const loadSeatLayoutById = async (seatLayoutId) => {
    if (!Validator.nonEmptyString(seatLayoutId, logger.error, 'seatLayoutId')) {
        throw new Error('Cannot load seat layout. Provided seatLayoutId is invalid.');
    }
    const state = createOrGetFetchedState(seatingDomainStore.data.seatLayouts, seatLayoutId);
    return await loadDataFromApi({
        api: () => ocapiClient.instance.v1.seating.masterData.seatLayout.getById(seatLayoutId),
        state,
        cacheDuration: getCacheDuration('seatingMasterData'),
        onSuccess
    });
};
const onSuccess = (response, cacheDuration) => {
    const { seatLayout, relatedData } = response;
    assignSeatLayoutRelatedData(relatedData, cacheDuration);
    return seatLayout;
};
//# sourceMappingURL=load-seat-layout-by-id.js.map